import { getCabOffers } from '../cabsLandingAPIs';
import { getScreenDensityName } from './displayUtils';

export type Offer = {
  newHeroOfferCardUrl: string;
  tncCtaText: string;
  maxDis: number;
  offerTxt: string;
  pTl: string;
  dStxt: string;
  hero: boolean;
  pwaTncUrl: string;
  dEtxt: string;
  heroUrl: string;
  dis: number;
  id: number;
  newHeroUrl: string;
  cardCTAText: string;
  url: string;
  inv: number;
  lob: string;
  skyBigFullImgUrl: string;
  cc: string;
};
export type DisplayOffer = {
  newHeroOfferCardUrl: string;
  heroUrl: string;
  dis: number;
  id: number;
  newHeroUrl: string;
  cardCTAText: string;
  url: string;
  lob: string;
  skyBigFullImgUrl: string;
  promoTitle: string;
  promoMessage: string;
  promoCode: string;
};

export const LOB = 'CABS';

export const fetchAndProcessOffers = async (): Promise<DisplayOffer[]> => {
  const cabOffers = await getCabOffers();
  const offers: Offer[] = _getLobOffers(cabOffers, LOB);
  const processedOffers: DisplayOffer[] = getOffersList(offers, LOB);
  return processedOffers;
};

export const _getLobOffers = (data, lob): Offer[] => {
  const lobCapitalised = lob.toUpperCase();
  const lobOffers =
    data.cardData.Offers_Listing.categoryOffersSequenceMap[lobCapitalised]
      .active;
  return lobOffers.map(
    offerId => data.cardData.Offers_Listing.promoMessagesMap[offerId]
  );
};

export const getOffersList = (
  offersList: Offer[] = [],
  lob
): DisplayOffer[] => {
  try {
    const lobUpperCase = lob.toUpperCase();
    const newOfferList = offersList.filter(offer => {
      if (offer?.lob) {
        return offer?.lob?.indexOf(lobUpperCase) >= 0;
      }
      return false;
    });

    let finalOfferList: DisplayOffer[] = [];
    if (newOfferList.length > 0) {
      newOfferList.forEach(originalOfferObj => {
        let promoTitle = originalOfferObj.pTl;
        if (
          originalOfferObj.dStxt &&
          originalOfferObj.offerTxt &&
          originalOfferObj.dEtxt
        ) {
          promoTitle = `${originalOfferObj.dStxt} ${originalOfferObj.offerTxt} ${originalOfferObj.dEtxt}`;
        }
        const newOffer: DisplayOffer = {
          id: originalOfferObj.id,
          newHeroUrl: originalOfferObj.newHeroUrl,
          cardCTAText: originalOfferObj.cardCTAText,
          newHeroOfferCardUrl: originalOfferObj.newHeroOfferCardUrl,
          promoTitle,
          promoMessage: originalOfferObj.pTl,
          promoCode: originalOfferObj.cc,
          dis: originalOfferObj.dis,
          url: originalOfferObj.url,
          skyBigFullImgUrl: originalOfferObj.skyBigFullImgUrl,
          lob: originalOfferObj.lob,
          heroUrl: originalOfferObj.heroUrl
        };
        finalOfferList.push(newOffer);
      });

      finalOfferList = finalOfferList.sort((offer1, offer2) =>
        offer1.dis < offer2.dis ? -1 : 1
      );
      return finalOfferList;
    }
  } catch (er) {
    console.error('Error in filtering offers');
  }
  return [];
};

export const getHeroImageUrl = (imageURL: string) => {
  if (imageURL) {
    const split = imageURL.split('appfest/');
    if (split.length >= 2 && split[0] && split[1]) {
      return ''.concat(
        split[0],
        'appfest/',
        getScreenDensityName(),
        '/',
        split[1]
      );
    }
    return imageURL;
  }
  return imageURL || '';
};

export const getSkyImageUrl = (imageURL: string) => {
  if (imageURL) {
    const split = imageURL.split('%s/');
    if (split.length >= 2 && split[0] && split[1]) {
      return ''.concat(split[0], getScreenDensityName(), '/', split[1]);
    }
    return imageURL;
  }
  return imageURL || '';
};
